// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tab-panel-wrap .nav.nav-tabs .nav-link {
  background: #303E4E;
  padding: 0 16px;
  border: none;
  line-height: 44px;
  color: #fff;
  text-decoration: underline;
  font-size: 15px;
  font-weight: 600;
  margin-right: 5px;
  border-radius: 5px 5px 0 0;
}

.tab-panel-wrap .nav-tabs {
  border-bottom: none;
}

.tab-panel-wrap .nav-tabs .nav-item.show .nav-link,
.tab-panel-wrap .nav-tabs .nav-link.active,
.tab-panel-wrap .nav-tabs .nav-link:hover {
  border: none;
  background: #F5F6FA;
  color: #525252;
  text-decoration: none;
}

.tab-panel-wrap .nav-tabs .nav-item {
  margin-bottom: 0;
}

.panel-content .panel-heading {
  background: #F5F6FA;
  padding: 35px 25px;
  margin-bottom: 30px;
  display: flow-root;
}

.panel-heading h3 {
  font-size: 28px;
  font-weight: bold;
  margin: 0;
}

.panel-content .filter-by {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}

.filter-by .cat-list label#select-aud-source-label {
  align-self: flex-start;
  margin-top: 6px;
  vertical-align: top;
  height: auto;
  line-height: normal;
  padding-top: 0;
  font-weight: normal;
}

.filter-by .cat-list {
  display: flex;
  align-items: flex-start;
  flex-wrap: nowrap;
}

.filter-by .cat-list ng-select.custom-multiselect {
  align-self: flex-start;
  margin-top: 0;
}

.filter-actions {
  align-self: flex-start;
  margin-top: 0;
  position: relative;
  top: 0;
}

.filter-actions .btn {
  margin-top: 0;
  position: relative;
  top: 0;
}

.filter-by .date {
  font-size: 18px;
  font-weight: normal;
}

.filter-by .date label {
  color: #2699FB;
  padding: 8px 12px;
  text-decoration: underline;
  border: none;
  background: none;
  font-weight: normal;
}

.filter-by .cat-list,
.sort-by {
  font-size: 16px;
  position: relative;
}

.filter-by .cat-list label,
.sort-by label {
  padding: 0 7px;
  text-decoration: underline;
  cursor: pointer;
}

.filter-by .cat-list .fa.fa-sort-desc,
.sort-by .fa.fa-sort-desc {
  color: #C2C3C7;
  font-size: 24px;
}

.filter-by .cat-list a:hover,
.sort-by a:hover {
  text-decoration: none;
}

.listing {
  border: none;
  margin-bottom: 25px;
}

.listing-heading {
  background: #303E4E;
  height: 57px;
}

.listing .listing-heading h3 {
  font-size: 24px;
  color: #fff;
  line-height: 57px;
  padding: 0 27px;
}

.listing .listing-heading h3 a {
  color: #fff;
}

.listing .list-content {
  padding: 25px;
}

.listing-heading a.collapsed .drop-icon,
.listing-heading .drop-icon {
  background: url(/assets/images/collapse-arrow.svg) no-repeat 0 0;
  width: 9px;
  height: 12px;
  display: inline-block;
  margin-left: 7px;
  transition: all 0.5s;
  transform: rotate(0deg);
}

.listing-heading .drop-icon {
  width: 9px;
  height: 13px;
  transform: rotate(90deg);
}

.listing .stapper {
  display: flex;
  margin-bottom: 10px;
}

.listing .stapper .steps {
  float: left;
  margin-right: 1%;
  width: 24%;
  background: url(/assets/images/stepper-icon.svg) no-repeat right 2px;
}

.listing .stapper .steps:last-child {
  background: none;
}

.stapper .steps label {
  font-size: 24px;
  line-height: 25px;
  background: #fff;
  padding-right: 10px;
}

.call-track-overview .call-track-content {
  display: flex;
}

.call-track-overview .call-track-content .track-box {
  float: left;
  width: 25%;
}

.call-track-content .track-box .digit {
  font-size: 50px;
  font-weight: 900;
  line-height: 50px;
  margin-bottom: 22px;
}

.call-track-content .track-box label {
  font-size: 20px;
  margin-bottom: 6px;
}

.call-track-content .track-box:not(:first-child) {
  padding: 36px 0 0 0;
}

.call-track-content .track-box .digit:last-child {
  margin-bottom: 0;
}

.call-detail-table.table th {
  background: #DCE0EB;
  border-bottom: none;
  color: #4D4F5C;
  font-size: 15px;
  font-weight: 700;
}

.call-detail-table.table-bordered td,
.call-detail-table.table-bordered th {
  border-color: #CED1D8;
}

.call-detail-table.table-bordered td {
  font-size: 15px;
  line-height: 24px;
}

.call-detail-table.table td.practice-location {
  width: 130px;
}

.call-detail-table td.practice-location h6 {
  font-weight: 600;
}

.call-detail-table td.result {
  color: #1AA69A;
}

.call-detail-table.table {
  margin-bottom: 0;
}

.table .app-set .yes,
.table .missed-opp .no {
  color: #1AA69A;
  font-weight: 600;
}

.table .app-set .no,
.table .missed-opp .yes {
  color: #A61A60;
  font-weight: 600;
}

.call-detail-table.table tbody tr:nth-child(even) {
  background: #F5F6FA;
}

.show-less {
  background: rgb(48, 62, 78);
  height: 43px;
  margin-top: 5rem;
  padding: 0 25px;
}

.show-less a {
  color: #fff;
  text-decoration: underline;
  line-height: 43px;
}

.call-detail-content .sort-by {
  margin: 0 0 5px 0;
}

.collapse-menu {
  position: absolute;
  background: #fff;
  min-width: 160px;
  z-index: 9;
  border: #DADBE0 solid 1px;
  padding: 10px 0;
  border-radius: 5px;
  right: 0;
  top: 32px;
}

.collapse-menu ul li {
  padding: 0 0 0 20px;
}

.collapse-menu ul li:hover,
.cat-list .collapse-menu ul li.active {
  background: #E8EAED;
}

.collapse-menu ul li a {
  text-decoration: none;
  line-height: 32px;
  display: block;
  color: #4D4F5C;
  font-size: 15px;
}

.select-aud-source {
  border: none;
  outline: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background: url(/assets/images/grey-dropdown.svg) no-repeat right center;
  background-size: 14px;
  padding-right: 15px;
  color: #2699FB;
}

.select-aud-source option:hover {
  background: #ddd;
}

a.play-button {
  background: url(/assets/images/play-icon.svg) no-repeat 0 0;
  width: 27px;
  height: 27px;
  display: inline-block;
}

a.stop-button {
  background: url(/assets/images/stop_icon.svg) no-repeat 0 0;
  width: 27px;
  height: 27px;
  display: inline-block;
}

.select-aud-source {
  max-width: 140px;
  margin-left: 20px;
}

.call-detail-content .list-content {
  padding: 10px !important;
}

.call-detail-content .table td,
.table th {
  padding: .5rem !important;
}

.filter-by {
  display: flex;
  align-items: flex-start !important;
  flex-wrap: wrap !important;
  width: 100%;
  margin-bottom: 40px;
  position: relative;
  z-index: 100;
  overflow: visible !important;
  min-height: 100px;
}

.filter-by .date {
  margin-right: 20px;
  display: flex;
  align-items: center;
  height: 34px;
}

.filter-by .date label {
  display: inline-block;
  margin-bottom: 0;
  margin-left: 10px;
  height: 34px;
  line-height: 20px;
  box-sizing: border-box;
}

.filter-by .cat-list {
  display: flex;
  align-items: flex-start;
  flex-wrap: nowrap;
  min-height: 34px;
  padding-bottom: 20px;
  position: relative;
  margin-bottom: 15px;
  width: auto;
}

.filter-by .cat-list label {
  margin-right: 10px;
  margin-bottom: 0;
  display: flex;
  align-items: center;
  height: 34px;
}

.custom-multiselect {
  min-height: 34px;
  width: auto;
  min-width: 230px;
  max-width: 320px;
  padding: 6px;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  margin-right: 10px;
  vertical-align: middle;
  text-overflow: ellipsis;
  overflow: visible !important;
}

.ng-select .ng-select-container {
  overflow: visible !important;
  min-height: 34px !important;
  height: auto !important;
}

.ng-select .ng-value-container {
  overflow: visible !important;
  flex-wrap: wrap !important;
  min-height: 34px !important;
  padding-top: 2px !important;
  padding-bottom: 2px !important;
}

.ng-dropdown-panel {
  z-index: 1050 !important;
}

.ng-select .ng-clear-wrapper {
  color: #999;
  font-size: 16px;
  cursor: pointer;
}

.ng-select .ng-clear-wrapper:hover {
  color: #D0021B;
}

ng-select.custom-multiselect {
  display: inline-block !important;
  width: auto !important;
  min-width: 180px !important;
  max-width: 360px !important;
  min-height: 34px !important;
  height: auto !important;
  overflow: visible !important;
  white-space: normal !important;
}

ng-select.custom-multiselect .ng-input input {
  height: 24px !important;
  padding: 0 2px !important;
}

.filter-by > div,
.filter-by label,
.filter-by .cat-list > * {
  vertical-align: middle;
}

.filter-by .date + .cat-list {
  margin-left: 15px;
  display: inline-flex;
  flex-wrap: nowrap;
}

.filter-by .date i.fa {
  position: relative;
  top: 1px;
}

@media (max-width: 768px) {
  .filter-by .date,
  .filter-by .cat-list {
    margin-bottom: 15px;
  }
}

#report {
  margin-top: 30px;
  position: relative;
  z-index: 10;
  clear: both;
}

.filter-by {
  margin-bottom: 10px;
}

.call-track-overview {
  position: relative;
  z-index: 10;
  clear: both;
  padding-top: 20px;
}

.filter-actions {
  display: inline-flex;
  align-items: center;
  flex-wrap: nowrap !important;
  margin-top: 0;
  margin-left: 10px;
}

.filter-actions .btn {
  margin-right: 10px;
}

ng-select.custom-multiselect {
  display: block !important;
  height: auto !important;
  min-height: 34px !important;
  max-height: none !important;
  white-space: normal !important;
  min-width: 180px !important;
  max-width: 360px !important;
  padding: 0 !important;
  border: none !important;
  background-color: transparent !important;
  margin-right: 10px !important;
  margin-bottom: 10px !important;
}

ng-select.custom-multiselect .ng-select-container {
  min-height: 34px !important;
  height: auto !important;
  border: 1px solid #d9d9d9 !important;
  border-radius: 4px !important;
  padding: 0 50px 0 6px !important;
  overflow: visible !important;
  text-overflow: ellipsis !important;
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  min-width: 0 !important;
  position: relative !important;
}

ng-select.custom-multiselect .ng-value-container {
  padding: 2px 0 !important;
  min-height: 30px !important;
  height: auto !important;
  overflow: visible !important;
  text-overflow: ellipsis !important;
  white-space: normal !important;
  word-wrap: break-word !important;
  display: flex !important;
  flex-wrap: wrap !important;
  align-items: center !important;
  width: calc(100% - 50px) !important;
  position: relative !important;
}

ng-select.custom-multiselect .ng-placeholder {
  padding: 0 2px !important;
}

ng-select.custom-multiselect .ng-value-container .ng-value {
  transition: all 0.1s ease-in-out !important;
}

ng-select.custom-multiselect .ng-input {
  padding: 0 !important;
  margin: 0 !important;
  position: relative !important;
  flex: 1 1 auto !important;
  width: 100% !important;
}

ng-select.custom-multiselect.ng-select-opened > .ng-select-container {
  overflow: visible !important;
}

ng-select.custom-multiselect .ng-input > input {
  height: 24px !important;
  padding: 0 !important;
}

ng-select.custom-multiselect .ng-arrow-wrapper {
  padding-right: 0 !important;
  width: 16px !important;
  height: 16px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  position: absolute !important;
  right: 5px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  z-index: 10 !important;
}

ng-select.custom-multiselect:hover .ng-select-container {
  border-color: #2699FB !important;
}

ng-select.custom-multiselect.ng-select-focused .ng-select-container {
  border-color: #2699FB !important;
  box-shadow: 0 0 0 0.2rem rgba(38, 153, 251, 0.25) !important;
}

ng-select.custom-multiselect .ng-value {
  margin: 2px 4px 2px 0 !important;
  font-size: 14px !important;
  background-color: #f1f1f1 !important;
  border-radius: 3px !important;
  padding: 2px 0 2px 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  max-width: calc(100% - 10px) !important;
  overflow: visible !important;
  text-overflow: ellipsis !important;
  position: relative !important;
  flex-shrink: 0 !important;
}

ng-select.custom-multiselect .ng-value-label {
  padding: 0 5px !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  display: inline-block !important;
  max-width: calc(100% - 25px) !important;
}

ng-select.custom-multiselect .ng-value-icon {
  border-right: 1px solid #ddd !important;
  padding: 0 5px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  height: 100% !important;
  min-width: 22px !important;
  position: relative !important;
  z-index: 5 !important;
}

ng-select.custom-multiselect .ng-value-icon:hover {
  background-color: #e6e6e6 !important;
  color: #D0021B !important;
}

ng-select.custom-multiselect .ng-clear-wrapper {
  color: #888 !important;
  font-size: 16px !important;
  width: 20px !important;
  height: 20px !important;
  line-height: 20px !important;
  text-align: center !important;
  border-radius: 50% !important;
  vertical-align: middle !important;
  margin-right: 0 !important;
  position: absolute !important;
  right: 25px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  z-index: 20 !important;
  cursor: pointer !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  background-color: #fff !important;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.1) !important;
}

ng-select.custom-multiselect .ng-clear-wrapper:hover {
  background-color: #f1f1f1 !important;
  color: #D0021B !important;
}

.panel-content.call-traking {
  overflow: visible !important;
  height: auto !important;
  min-height: 100%;
  position: relative;
}

.ng-dropdown-panel {
  position: absolute !important;
  z-index: 1050 !important;
  max-height: 300px !important;
  overflow-y: auto !important;
}

ng-select.custom-multiselect .ng-dropdown-panel {
  min-width: 100% !important;
  max-width: -moz-fit-content !important;
  max-width: fit-content !important;
  margin-top: 2px !important;
}

.panel-heading {
  position: relative;
  z-index: 50;
}

.ng-dropdown-panel-items {
  max-height: 250px !important;
  overflow-y: auto !important;
}

@media (min-width: 992px) {
  .filter-by {
    align-items: flex-start !important;
  }

  .filter-by .cat-list {
    display: flex;
    flex-wrap: wrap;
  }
}

@media (max-width: 991px) {
  .filter-by {
    flex-direction: column;
    flex-wrap: wrap !important;
  }

  .filter-by .date,
  .filter-by .cat-list {
    width: 100%;
    margin-bottom: 15px;
  }

  .filter-by .cat-list {
    flex-wrap: wrap !important;
  }

  ng-select.custom-multiselect,
  .filter-actions {
    width: auto;
    margin-bottom: 15px;
  }

  .filter-actions {
    justify-content: flex-start;
  }

  #report {
    margin-top: 40px;
  }
}

.filter-by .cat-list {
  display: flex;
  align-items: center !important;
  flex-wrap: nowrap !important;
  min-height: 34px;
  padding-bottom: 20px;
  position: relative;
  margin-bottom: 15px;
  width: auto;
}

ng-select.custom-multiselect {
  display: inline-block !important;
  min-width: 230px !important;
  max-width: 320px !important;
  flex-shrink: 0 !important;
  margin-right: 10px !important;
  overflow: visible !important;
}

.filter-by .cat-list label {
  white-space: nowrap;
  margin-right: 10px;
}

.filter-actions {
  display: inline-flex !important;
  flex-wrap: nowrap !important;
  white-space: nowrap;
  margin-left: 10px;
}

@media (max-width: 991px) {
  .filter-by .cat-list {
    flex-wrap: wrap !important;
  }

  ng-select.custom-multiselect {
    margin-bottom: 10px;
  }
}

.filter-top-row {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: flex-start;
}

.filter-dropdown-container {
  display: flex;
  flex-direction: column;
  margin-right: 10px;
}

.filter-buttons-row {
  display: flex;
  margin-top: 5px;   width: 100%;
  justify-content: flex-start;
}

.filter-buttons-row .btn {
  height: 28px;   padding: 0 10px;
  font-size: 12px;
}

.filter-buttons-row .btn.mr-1 {
  margin-right: 5px !important;
}

.cat-list {
  display: flex;
  align-items: flex-start !important;
}

ng-select.custom-multiselect .ng-clear-wrapper {
  display: none !important;
}

ng-select.custom-multiselect .ng-value-icon {
  display: inline-flex !important;
}

@media (max-width: 768px) {
  .filter-top-row {
    flex-direction: column;
  }

  .filter-dropdown-container {
    width: 100%;
    margin-right: 0;
    margin-bottom: 10px;
  }
}

.location-select {
  margin-right: 10px;
}

.filter-action-row {
    position: static;
  margin-top: 10px;
  display: flex;
}

.filter-action-row .btn {
  margin-right: 10px;
  height: 34px;
}

.filter-by {
  position: relative;
}


@media (max-width: 991px) {
  .filter-action-row {
    position: relative;
    left: auto;
    top: auto;
    margin-top: 10px;
    margin-left: 0;   }
}
.filter-action-row app-reset-button {
  display: inline-block;
  vertical-align: middle;
}`, "",{"version":3,"sources":["webpack://./src/app/components/reporting/call-tracking-report/call-tracking-report.component.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,MAAM;AACR;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,0BAA0B;EAC1B,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;EACd,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,gEAAgE;EAChE,UAAU;EACV,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,oEAAoE;AACtE;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,wBAAwB;EACxB,qBAAqB;EACrB,wEAAwE;EACxE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2DAA2D;EAC3D,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,2DAA2D;EAC3D,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,0BAA0B;EAC1B,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;EACtB,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE;;IAEE,mBAAmB;EACrB;AACF;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,4BAA4B;EAC5B,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,8BAA8B;EAC9B,2BAA2B;EAC3B,2BAA2B;EAC3B,qBAAqB;EACrB,uBAAuB;EACvB,wCAAwC;EACxC,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,oCAAoC;EACpC,6BAA6B;EAC7B,gCAAgC;EAChC,4BAA4B;EAC5B,kCAAkC;EAClC,wBAAwB;EACxB,8BAA8B;EAC9B,8BAA8B;EAC9B,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;EACvB,4BAA4B;EAC5B,kCAAkC;EAClC,8BAA8B;EAC9B,gCAAgC;EAChC,wBAAwB;EACxB,0BAA0B;EAC1B,8BAA8B;EAC9B,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,6BAA6B;EAC7B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,6BAA6B;EAC7B,qBAAqB;EACrB,mBAAmB;EACnB,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,4DAA4D;AAC9D;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,oCAAoC;EACpC,6BAA6B;EAC7B,+BAA+B;EAC/B,+BAA+B;EAC/B,8BAA8B;EAC9B,uCAAuC;EACvC,4BAA4B;EAC5B,kCAAkC;EAClC,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,2BAA2B;EAC3B,kCAAkC;EAClC,gCAAgC;EAChC,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;EACvC,yBAAyB;EACzB,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,uBAAuB;EACvB,0BAA0B;EAC1B,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,6BAA6B;EAC7B,6BAA6B;EAC7B,iCAAiC;EACjC,0BAA0B;EAC1B,6BAA6B;EAC7B,sBAAsB;EACtB,mBAAmB;EACnB,sCAAsC;EACtC,sBAAsB;EACtB,0BAA0B;EAC1B,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,iCAAiC;EACjC,iDAAiD;AACnD;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,sCAAiC;EAAjC,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE;IACE,kCAAkC;EACpC;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,0BAA0B;EAC5B;;EAEA;;IAEE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,4BAA4B;EAC5B,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAyB;EACzB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,WAAW;EACX,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe,IAAI,WAAW;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,YAAY,IAAI,eAAe;EAC/B,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;IACI,gBAAgB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;;AAGA;EACE;IACE,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,cAAc,IAAI;AACtB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB","sourcesContent":[".tab-panel-wrap .nav.nav-tabs .nav-link {\n  background: #303E4E;\n  padding: 0 16px;\n  border: none;\n  line-height: 44px;\n  color: #fff;\n  text-decoration: underline;\n  font-size: 15px;\n  font-weight: 600;\n  margin-right: 5px;\n  border-radius: 5px 5px 0 0;\n}\n\n.tab-panel-wrap .nav-tabs {\n  border-bottom: none;\n}\n\n.tab-panel-wrap .nav-tabs .nav-item.show .nav-link,\n.tab-panel-wrap .nav-tabs .nav-link.active,\n.tab-panel-wrap .nav-tabs .nav-link:hover {\n  border: none;\n  background: #F5F6FA;\n  color: #525252;\n  text-decoration: none;\n}\n\n.tab-panel-wrap .nav-tabs .nav-item {\n  margin-bottom: 0;\n}\n\n.panel-content .panel-heading {\n  background: #F5F6FA;\n  padding: 35px 25px;\n  margin-bottom: 30px;\n  display: flow-root;\n}\n\n.panel-heading h3 {\n  font-size: 28px;\n  font-weight: bold;\n  margin: 0;\n}\n\n.panel-content .filter-by {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 15px;\n}\n\n.filter-by .cat-list label#select-aud-source-label {\n  align-self: flex-start;\n  margin-top: 6px;\n  vertical-align: top;\n  height: auto;\n  line-height: normal;\n  padding-top: 0;\n  font-weight: normal;\n}\n\n.filter-by .cat-list {\n  display: flex;\n  align-items: flex-start;\n  flex-wrap: nowrap;\n}\n\n.filter-by .cat-list ng-select.custom-multiselect {\n  align-self: flex-start;\n  margin-top: 0;\n}\n\n.filter-actions {\n  align-self: flex-start;\n  margin-top: 0;\n  position: relative;\n  top: 0;\n}\n\n.filter-actions .btn {\n  margin-top: 0;\n  position: relative;\n  top: 0;\n}\n\n.filter-by .date {\n  font-size: 18px;\n  font-weight: normal;\n}\n\n.filter-by .date label {\n  color: #2699FB;\n  padding: 8px 12px;\n  text-decoration: underline;\n  border: none;\n  background: none;\n  font-weight: normal;\n}\n\n.filter-by .cat-list,\n.sort-by {\n  font-size: 16px;\n  position: relative;\n}\n\n.filter-by .cat-list label,\n.sort-by label {\n  padding: 0 7px;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.filter-by .cat-list .fa.fa-sort-desc,\n.sort-by .fa.fa-sort-desc {\n  color: #C2C3C7;\n  font-size: 24px;\n}\n\n.filter-by .cat-list a:hover,\n.sort-by a:hover {\n  text-decoration: none;\n}\n\n.listing {\n  border: none;\n  margin-bottom: 25px;\n}\n\n.listing-heading {\n  background: #303E4E;\n  height: 57px;\n}\n\n.listing .listing-heading h3 {\n  font-size: 24px;\n  color: #fff;\n  line-height: 57px;\n  padding: 0 27px;\n}\n\n.listing .listing-heading h3 a {\n  color: #fff;\n}\n\n.listing .list-content {\n  padding: 25px;\n}\n\n.listing-heading a.collapsed .drop-icon,\n.listing-heading .drop-icon {\n  background: url(/assets/images/collapse-arrow.svg) no-repeat 0 0;\n  width: 9px;\n  height: 12px;\n  display: inline-block;\n  margin-left: 7px;\n  transition: all 0.5s;\n  transform: rotate(0deg);\n}\n\n.listing-heading .drop-icon {\n  width: 9px;\n  height: 13px;\n  transform: rotate(90deg);\n}\n\n.listing .stapper {\n  display: flex;\n  margin-bottom: 10px;\n}\n\n.listing .stapper .steps {\n  float: left;\n  margin-right: 1%;\n  width: 24%;\n  background: url(/assets/images/stepper-icon.svg) no-repeat right 2px;\n}\n\n.listing .stapper .steps:last-child {\n  background: none;\n}\n\n.stapper .steps label {\n  font-size: 24px;\n  line-height: 25px;\n  background: #fff;\n  padding-right: 10px;\n}\n\n.call-track-overview .call-track-content {\n  display: flex;\n}\n\n.call-track-overview .call-track-content .track-box {\n  float: left;\n  width: 25%;\n}\n\n.call-track-content .track-box .digit {\n  font-size: 50px;\n  font-weight: 900;\n  line-height: 50px;\n  margin-bottom: 22px;\n}\n\n.call-track-content .track-box label {\n  font-size: 20px;\n  margin-bottom: 6px;\n}\n\n.call-track-content .track-box:not(:first-child) {\n  padding: 36px 0 0 0;\n}\n\n.call-track-content .track-box .digit:last-child {\n  margin-bottom: 0;\n}\n\n.call-detail-table.table th {\n  background: #DCE0EB;\n  border-bottom: none;\n  color: #4D4F5C;\n  font-size: 15px;\n  font-weight: 700;\n}\n\n.call-detail-table.table-bordered td,\n.call-detail-table.table-bordered th {\n  border-color: #CED1D8;\n}\n\n.call-detail-table.table-bordered td {\n  font-size: 15px;\n  line-height: 24px;\n}\n\n.call-detail-table.table td.practice-location {\n  width: 130px;\n}\n\n.call-detail-table td.practice-location h6 {\n  font-weight: 600;\n}\n\n.call-detail-table td.result {\n  color: #1AA69A;\n}\n\n.call-detail-table.table {\n  margin-bottom: 0;\n}\n\n.table .app-set .yes,\n.table .missed-opp .no {\n  color: #1AA69A;\n  font-weight: 600;\n}\n\n.table .app-set .no,\n.table .missed-opp .yes {\n  color: #A61A60;\n  font-weight: 600;\n}\n\n.call-detail-table.table tbody tr:nth-child(even) {\n  background: #F5F6FA;\n}\n\n.show-less {\n  background: rgb(48, 62, 78);\n  height: 43px;\n  margin-top: 5rem;\n  padding: 0 25px;\n}\n\n.show-less a {\n  color: #fff;\n  text-decoration: underline;\n  line-height: 43px;\n}\n\n.call-detail-content .sort-by {\n  margin: 0 0 5px 0;\n}\n\n.collapse-menu {\n  position: absolute;\n  background: #fff;\n  min-width: 160px;\n  z-index: 9;\n  border: #DADBE0 solid 1px;\n  padding: 10px 0;\n  border-radius: 5px;\n  right: 0;\n  top: 32px;\n}\n\n.collapse-menu ul li {\n  padding: 0 0 0 20px;\n}\n\n.collapse-menu ul li:hover,\n.cat-list .collapse-menu ul li.active {\n  background: #E8EAED;\n}\n\n.collapse-menu ul li a {\n  text-decoration: none;\n  line-height: 32px;\n  display: block;\n  color: #4D4F5C;\n  font-size: 15px;\n}\n\n.select-aud-source {\n  border: none;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  background: url(/assets/images/grey-dropdown.svg) no-repeat right center;\n  background-size: 14px;\n  padding-right: 15px;\n  color: #2699FB;\n}\n\n.select-aud-source option:hover {\n  background: #ddd;\n}\n\na.play-button {\n  background: url(/assets/images/play-icon.svg) no-repeat 0 0;\n  width: 27px;\n  height: 27px;\n  display: inline-block;\n}\n\na.stop-button {\n  background: url(/assets/images/stop_icon.svg) no-repeat 0 0;\n  width: 27px;\n  height: 27px;\n  display: inline-block;\n}\n\n.select-aud-source {\n  max-width: 140px;\n  margin-left: 20px;\n}\n\n.call-detail-content .list-content {\n  padding: 10px !important;\n}\n\n.call-detail-content .table td,\n.table th {\n  padding: .5rem !important;\n}\n\n.filter-by {\n  display: flex;\n  align-items: flex-start !important;\n  flex-wrap: wrap !important;\n  width: 100%;\n  margin-bottom: 40px;\n  position: relative;\n  z-index: 100;\n  overflow: visible !important;\n  min-height: 100px;\n}\n\n.filter-by .date {\n  margin-right: 20px;\n  display: flex;\n  align-items: center;\n  height: 34px;\n}\n\n.filter-by .date label {\n  display: inline-block;\n  margin-bottom: 0;\n  margin-left: 10px;\n  height: 34px;\n  line-height: 20px;\n  box-sizing: border-box;\n}\n\n.filter-by .cat-list {\n  display: flex;\n  align-items: flex-start;\n  flex-wrap: nowrap;\n  min-height: 34px;\n  padding-bottom: 20px;\n  position: relative;\n  margin-bottom: 15px;\n  width: auto;\n}\n\n.filter-by .cat-list label {\n  margin-right: 10px;\n  margin-bottom: 0;\n  display: flex;\n  align-items: center;\n  height: 34px;\n}\n\n.custom-multiselect {\n  min-height: 34px;\n  width: auto;\n  min-width: 230px;\n  max-width: 320px;\n  padding: 6px;\n  background-color: #fff;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  margin-right: 10px;\n  vertical-align: middle;\n  text-overflow: ellipsis;\n  overflow: visible !important;\n}\n\n.ng-select .ng-select-container {\n  overflow: visible !important;\n  min-height: 34px !important;\n  height: auto !important;\n}\n\n.ng-select .ng-value-container {\n  overflow: visible !important;\n  flex-wrap: wrap !important;\n  min-height: 34px !important;\n  padding-top: 2px !important;\n  padding-bottom: 2px !important;\n}\n\n.ng-dropdown-panel {\n  z-index: 1050 !important;\n}\n\n.ng-select .ng-clear-wrapper {\n  color: #999;\n  font-size: 16px;\n  cursor: pointer;\n}\n\n.ng-select .ng-clear-wrapper:hover {\n  color: #D0021B;\n}\n\nng-select.custom-multiselect {\n  display: inline-block !important;\n  width: auto !important;\n  min-width: 180px !important;\n  max-width: 360px !important;\n  min-height: 34px !important;\n  height: auto !important;\n  overflow: visible !important;\n  white-space: normal !important;\n}\n\nng-select.custom-multiselect .ng-input input {\n  height: 24px !important;\n  padding: 0 2px !important;\n}\n\n.filter-by > div,\n.filter-by label,\n.filter-by .cat-list > * {\n  vertical-align: middle;\n}\n\n.filter-by .date + .cat-list {\n  margin-left: 15px;\n  display: inline-flex;\n  flex-wrap: nowrap;\n}\n\n.filter-by .date i.fa {\n  position: relative;\n  top: 1px;\n}\n\n@media (max-width: 768px) {\n  .filter-by .date,\n  .filter-by .cat-list {\n    margin-bottom: 15px;\n  }\n}\n\n#report {\n  margin-top: 30px;\n  position: relative;\n  z-index: 10;\n  clear: both;\n}\n\n.filter-by {\n  margin-bottom: 10px;\n}\n\n.call-track-overview {\n  position: relative;\n  z-index: 10;\n  clear: both;\n  padding-top: 20px;\n}\n\n.filter-actions {\n  display: inline-flex;\n  align-items: center;\n  flex-wrap: nowrap !important;\n  margin-top: 0;\n  margin-left: 10px;\n}\n\n.filter-actions .btn {\n  margin-right: 10px;\n}\n\nng-select.custom-multiselect {\n  display: block !important;\n  height: auto !important;\n  min-height: 34px !important;\n  max-height: none !important;\n  white-space: normal !important;\n  min-width: 180px !important;\n  max-width: 360px !important;\n  padding: 0 !important;\n  border: none !important;\n  background-color: transparent !important;\n  margin-right: 10px !important;\n  margin-bottom: 10px !important;\n}\n\nng-select.custom-multiselect .ng-select-container {\n  min-height: 34px !important;\n  height: auto !important;\n  border: 1px solid #d9d9d9 !important;\n  border-radius: 4px !important;\n  padding: 0 50px 0 6px !important;\n  overflow: visible !important;\n  text-overflow: ellipsis !important;\n  display: flex !important;\n  flex-direction: row !important;\n  align-items: center !important;\n  min-width: 0 !important;\n  position: relative !important;\n}\n\nng-select.custom-multiselect .ng-value-container {\n  padding: 2px 0 !important;\n  min-height: 30px !important;\n  height: auto !important;\n  overflow: visible !important;\n  text-overflow: ellipsis !important;\n  white-space: normal !important;\n  word-wrap: break-word !important;\n  display: flex !important;\n  flex-wrap: wrap !important;\n  align-items: center !important;\n  width: calc(100% - 50px) !important;\n  position: relative !important;\n}\n\nng-select.custom-multiselect .ng-placeholder {\n  padding: 0 2px !important;\n}\n\nng-select.custom-multiselect .ng-value-container .ng-value {\n  transition: all 0.1s ease-in-out !important;\n}\n\nng-select.custom-multiselect .ng-input {\n  padding: 0 !important;\n  margin: 0 !important;\n  position: relative !important;\n  flex: 1 1 auto !important;\n  width: 100% !important;\n}\n\nng-select.custom-multiselect.ng-select-opened > .ng-select-container {\n  overflow: visible !important;\n}\n\nng-select.custom-multiselect .ng-input > input {\n  height: 24px !important;\n  padding: 0 !important;\n}\n\nng-select.custom-multiselect .ng-arrow-wrapper {\n  padding-right: 0 !important;\n  width: 16px !important;\n  height: 16px !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  position: absolute !important;\n  right: 5px !important;\n  top: 50% !important;\n  transform: translateY(-50%) !important;\n  z-index: 10 !important;\n}\n\nng-select.custom-multiselect:hover .ng-select-container {\n  border-color: #2699FB !important;\n}\n\nng-select.custom-multiselect.ng-select-focused .ng-select-container {\n  border-color: #2699FB !important;\n  box-shadow: 0 0 0 0.2rem rgba(38, 153, 251, 0.25) !important;\n}\n\nng-select.custom-multiselect .ng-value {\n  margin: 2px 4px 2px 0 !important;\n  font-size: 14px !important;\n  background-color: #f1f1f1 !important;\n  border-radius: 3px !important;\n  padding: 2px 0 2px 0 !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  max-width: calc(100% - 10px) !important;\n  overflow: visible !important;\n  text-overflow: ellipsis !important;\n  position: relative !important;\n  flex-shrink: 0 !important;\n}\n\nng-select.custom-multiselect .ng-value-label {\n  padding: 0 5px !important;\n  white-space: nowrap !important;\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n  display: inline-block !important;\n  max-width: calc(100% - 25px) !important;\n}\n\nng-select.custom-multiselect .ng-value-icon {\n  border-right: 1px solid #ddd !important;\n  padding: 0 5px !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  height: 100% !important;\n  min-width: 22px !important;\n  position: relative !important;\n  z-index: 5 !important;\n}\n\nng-select.custom-multiselect .ng-value-icon:hover {\n  background-color: #e6e6e6 !important;\n  color: #D0021B !important;\n}\n\nng-select.custom-multiselect .ng-clear-wrapper {\n  color: #888 !important;\n  font-size: 16px !important;\n  width: 20px !important;\n  height: 20px !important;\n  line-height: 20px !important;\n  text-align: center !important;\n  border-radius: 50% !important;\n  vertical-align: middle !important;\n  margin-right: 0 !important;\n  position: absolute !important;\n  right: 25px !important;\n  top: 50% !important;\n  transform: translateY(-50%) !important;\n  z-index: 20 !important;\n  cursor: pointer !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  background-color: #fff !important;\n  box-shadow: 0 0 2px rgba(0, 0, 0, 0.1) !important;\n}\n\nng-select.custom-multiselect .ng-clear-wrapper:hover {\n  background-color: #f1f1f1 !important;\n  color: #D0021B !important;\n}\n\n.panel-content.call-traking {\n  overflow: visible !important;\n  height: auto !important;\n  min-height: 100%;\n  position: relative;\n}\n\n.ng-dropdown-panel {\n  position: absolute !important;\n  z-index: 1050 !important;\n  max-height: 300px !important;\n  overflow-y: auto !important;\n}\n\nng-select.custom-multiselect .ng-dropdown-panel {\n  min-width: 100% !important;\n  max-width: fit-content !important;\n  margin-top: 2px !important;\n}\n\n.panel-heading {\n  position: relative;\n  z-index: 50;\n}\n\n.ng-dropdown-panel-items {\n  max-height: 250px !important;\n  overflow-y: auto !important;\n}\n\n@media (min-width: 992px) {\n  .filter-by {\n    align-items: flex-start !important;\n  }\n\n  .filter-by .cat-list {\n    display: flex;\n    flex-wrap: wrap;\n  }\n}\n\n@media (max-width: 991px) {\n  .filter-by {\n    flex-direction: column;\n    flex-wrap: wrap !important;\n  }\n\n  .filter-by .date,\n  .filter-by .cat-list {\n    width: 100%;\n    margin-bottom: 15px;\n  }\n\n  .filter-by .cat-list {\n    flex-wrap: wrap !important;\n  }\n\n  ng-select.custom-multiselect,\n  .filter-actions {\n    width: auto;\n    margin-bottom: 15px;\n  }\n\n  .filter-actions {\n    justify-content: flex-start;\n  }\n\n  #report {\n    margin-top: 40px;\n  }\n}\n\n.filter-by .cat-list {\n  display: flex;\n  align-items: center !important;\n  flex-wrap: nowrap !important;\n  min-height: 34px;\n  padding-bottom: 20px;\n  position: relative;\n  margin-bottom: 15px;\n  width: auto;\n}\n\nng-select.custom-multiselect {\n  display: inline-block !important;\n  min-width: 230px !important;\n  max-width: 320px !important;\n  flex-shrink: 0 !important;\n  margin-right: 10px !important;\n  overflow: visible !important;\n}\n\n.filter-by .cat-list label {\n  white-space: nowrap;\n  margin-right: 10px;\n}\n\n.filter-actions {\n  display: inline-flex !important;\n  flex-wrap: nowrap !important;\n  white-space: nowrap;\n  margin-left: 10px;\n}\n\n@media (max-width: 991px) {\n  .filter-by .cat-list {\n    flex-wrap: wrap !important;\n  }\n\n  ng-select.custom-multiselect {\n    margin-bottom: 10px;\n  }\n}\n\n.filter-top-row {\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.filter-dropdown-container {\n  display: flex;\n  flex-direction: column;\n  margin-right: 10px;\n}\n\n.filter-buttons-row {\n  display: flex;\n  margin-top: 5px;   width: 100%;\n  justify-content: flex-start;\n}\n\n.filter-buttons-row .btn {\n  height: 28px;   padding: 0 10px;\n  font-size: 12px;\n}\n\n.filter-buttons-row .btn.mr-1 {\n  margin-right: 5px !important;\n}\n\n.cat-list {\n  display: flex;\n  align-items: flex-start !important;\n}\n\nng-select.custom-multiselect .ng-clear-wrapper {\n  display: none !important;\n}\n\nng-select.custom-multiselect .ng-value-icon {\n  display: inline-flex !important;\n}\n\n@media (max-width: 768px) {\n  .filter-top-row {\n    flex-direction: column;\n  }\n\n  .filter-dropdown-container {\n    width: 100%;\n    margin-right: 0;\n    margin-bottom: 10px;\n  }\n}\n\n.location-select {\n  margin-right: 10px;\n}\n\n.filter-action-row {\n    position: static;\n  margin-top: 10px;\n  display: flex;\n}\n\n.filter-action-row .btn {\n  margin-right: 10px;\n  height: 34px;\n}\n\n.filter-by {\n  position: relative;\n}\n\n\n@media (max-width: 991px) {\n  .filter-action-row {\n    position: relative;\n    left: auto;\n    top: auto;\n    margin-top: 10px;\n    margin-left: 0;   }\n}\n.filter-action-row app-reset-button {\n  display: inline-block;\n  vertical-align: middle;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
